
<ngb-rating class="rating" [formControl]="formControl" [max]="to.max">
</ngb-rating>
